<mat-toolbar>
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>Mapear Substituição - {{textoTpContaView}}</h1>
    <span flex></span>
    <div class="posicionar-direita">
      <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
        <mat-icon>fullscreen_exit</mat-icon>
      </button>
      <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
        <mat-icon>fullscreen</mat-icon>
      </button>
      <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>

<div mat-dialog-actions>
  <button mat-raised-button color="primary" matTooltip="Substituir" (click)="substituir()"
          [disabled]="!selecionadas.length">
    <mat-icon>compare_arrows</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="md-dialog-content">

    <!-- Tipo de busca -->
    <mat-radio-group [formControl]="tipoBusca">
      <mat-radio-button value="ID">Buscar por ID</mat-radio-button>
      <mat-radio-button value="PARCEIRO">Buscar por Parceiro</mat-radio-button>
      <mat-radio-button value="DESCRICAO">Buscar por Descrição</mat-radio-button>
    </mat-radio-group>

    <!-- Buscar por ID -->
    <div class="row campo-busca" *ngIf="tipoBusca.value === 'ID'">
      <mat-form-field class="col-md-3 col-xs-12">
        <input matInput type="number" placeholder="ID da Conta Parcela" [formControl]="idBusca"
          (keyup.enter)="buscarPorId()">
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="buscarPorId()" [disabled]="!idBusca.value">
        Buscar
      </button>
      
    </div>

    <div class="row">
      <div class="table-responsive" *ngIf="buscouPorId">
        <table mat-table [dataSource]="resultadoPorId ? [resultadoPorId] : []"
              class="mat-elevation-z2 tabela-conta-parcela">

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let conta">
              #{{ conta.contaParcelaId }}
            </td>
          </ng-container>

          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td mat-cell *matCellDef="let conta">
              {{ conta.descricao }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dataVencimento">
            <th mat-header-cell *matHeaderCellDef>Data de vencimento</th>
            <td mat-cell *matCellDef="let conta">
              {{ conta.dataVencimento | date:'dd/MM/yyyy' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef>Valor</th>
            <td mat-cell *matCellDef="let conta">
              {{ conta.valorParcela | currency:'BRL' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="acao">
            <th mat-header-cell *matHeaderCellDef>Ação</th>
            <td mat-cell *matCellDef="let conta">
              <button
                mat-mini-fab
                color="primary"
                (click)="selecionarResultadoPorId()"
                [disabled]="conta.jaSelecionada">
                <mat-icon>add</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row
              *matHeaderRowDef="['id', 'descricao', 'dataVencimento', 'valor', 'acao']">
          </tr>

          <tr mat-row
              *matRowDef="let row; columns: ['id', 'descricao', 'dataVencimento', 'valor', 'acao'];">
          </tr>
          <!-- Linha exibida quando não há dados -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="5">
              Nenhuma Conta Parcela encontrada com este ID.
            </td>
          </tr>
        </table>
      </div>

    </div>

    <!-- Buscar por Parceiro / Descrição -->
    <div class="row campo-busca" *ngIf="tipoBusca.value !== 'ID'">
      <mat-form-field class="col-md-6 col-xs-12">
        <input matInput
          [placeholder]="tipoBusca.value === 'PARCEIRO' ? 'CNPJ / Razão Social / Nome Fantasia (mín. 3 caracteres)' : 'Descrição (mín. 3 caracteres)'"
          [formControl]="termoBusca" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="aoSelecionarOpcao($event.option.value)">
          <mat-option *ngFor="let conta of opcoes" [value]="conta" [disabled]="conta.jaSelecionada">
            <div>#{{conta.contaParcelaId}} - {{conta.descricao}}</div>
          </mat-option>
          <mat-option *ngIf="temMais" [disabled]="carregando">
            <div (click)="verMais($event)" class="ver-mais">Ver mais</div>
          </mat-option>
        </mat-autocomplete>
        <mat-progress-bar mode="indeterminate" color="primary" *ngIf="carregando">
        </mat-progress-bar>
      </mat-form-field>
    </div>

    <!-- Contas parcelas selecionadas para a substituição -->
    <h3>Contas Parcelas selecionadas ({{ selecionadas.length }})</h3>

    <div class="table-responsive" *ngIf="selecionadas.length > 0">
      <table mat-table [dataSource]="selecionadas"
            class="mat-elevation-z2 tabela-conta-parcela">

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let conta">
            #{{ conta.contaParcelaId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef>Descrição</th>
          <td mat-cell *matCellDef="let conta">
            {{ conta.descricao }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dataVencimento">
          <th mat-header-cell *matHeaderCellDef>Data de vencimento</th>
          <td mat-cell *matCellDef="let conta">
            {{ conta.dataVencimento | date:'dd/MM/yyyy' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef>Valor</th>
          <td mat-cell *matCellDef="let conta">
            {{ conta.valorParcela | currency:'BRL' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="acao">
          <th mat-header-cell *matHeaderCellDef>Ação</th>
          <td mat-cell *matCellDef="let conta">
            <button
              mat-mini-fab
              color="warn"
              matTooltip="Remover"
              class="btn-acao"
              (click)="removerSelecionada(conta)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row
            *matHeaderRowDef="['id', 'descricao', 'dataVencimento', 'valor', 'acao']">
        </tr>

        <tr mat-row
            *matRowDef="let row; columns: ['id', 'descricao', 'dataVencimento', 'valor', 'acao'];">
        </tr>
      </table>
    </div>

    <p *ngIf="!selecionadas.length">
      Nenhuma Conta Parcela selecionada.
    </p>
  </div>

</mat-dialog-content>
